import { render, staticRenderFns } from "./formRencanaAksi.vue?vue&type=template&id=2fa0a598&"
import script from "./formRencanaAksi.vue?vue&type=script&lang=js&"
export * from "./formRencanaAksi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports